import React from 'react'

function OurMembers() {

    const members = [
        {
            name: "Dr. Pooja Pandey Tripathi",
            image: "/assets/members/Pooja.png",
            role: "Physiotherapist"
        },
        {
            name: "Dr. Jayachandran Rajan",
            image: "/assets/members/Jay.png",
            role: "Personal Trainer"
        },
        {
            name: "Babul Saha",
            image: "/assets/members/babul.png",
            role: "Personal Trainer"
        },
        {
            name: "Shenoy Joseph Thomas",
            image: "/assets/members/shenoy.png",
            role: "Personal Trainer"
        },
    ]

    return (
        <section className="w-full bg-gradient-radial py-12 lg:py-15">
            <div className="container mx-auto px-4 lg:px-15">
                <h2
                    className="text-2xl sm:text-3xl lg:text-5xl font-bold font-urbanist text-white text-center sm:text-center mb-8 lg:mb-12">
                    Our Valued Members
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 p-4 bg-white rounded-[3rem]">
                    {
                        members.map((memberDetails, index) => {
                            return (
                                <div className="p-4 rounded-xl flex flex-col items-center text-center transition-transform hover:scale-105" key={index}>
                                    <div className='w-[11rem] h-[11rem] rounded-full border-[3px] border-black mb-4'>
                                        <img className="w-full h-full rounded-full" src={memberDetails.image} alt={memberDetails.name} />
                                    </div>
                                    <h3 className="text-neutral-950 text-[1.2rem] font-semibold font-poppins leading-normal">
                                        {memberDetails.name}
                                    </h3>
                                    <p className="text-neutral-600 text-base font-semibold font-poppins leading-normal">
                                        {memberDetails.role}
                                    </p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </section>
    )
}

export default OurMembers